 mutation UserProfileLastUsedUpdate {
    userProfileLastUsedUpdate(input: {}) {
      userProfileLoggingInfo {
        desktopLoggingIntervalMinutes
        isDesktopSignoutEnforced
        isMobileSignoutEnforced
        mobileLoggingIntervalMinutes
      }
    }
  }